export default __webpack_public_path__ + "static/media/insight-icon.7cb30b82.svg";